import React from 'react';
import { FormItemProps } from 'antd';
import FormItem from '@/components/ui/FormItem';
import InputText from '@/components/ui/InputText';

interface TaskNameProps extends FormItemProps {
	fieldName?: string;
	isRequired?: boolean;
}

export function TaskName({ fieldName = '', isRequired = false, ...props }: Readonly<TaskNameProps>): JSX.Element {
	return (
		<FormItem name={fieldName} required={isRequired} {...props}>
			<InputText placeholder="Task Name" />
		</FormItem>
	);
}
